/**
 * Exchange Registry — maps exchange name to its adapter.
 * Add new exchanges here (OKX, MEXC, Bitget, Bybit...).
 */

import { ExchangeAdapter } from "./types";
import { binanceAdapter } from "./binance";
import { okxAdapter } from "./okx";
import { mexcAdapter } from "./mexc";
import { bitgetAdapter } from "./bitget";

// ─── Registry map ─────────────────────────────────────────────
const adapters: Record<string, ExchangeAdapter> = {
  binance: binanceAdapter,
  okx: okxAdapter,
  mexc: mexcAdapter,
  bitget: bitgetAdapter,
  // bybit: bybitAdapter,
};

/** Get adapter by name. Falls back to Binance if not found. */
export function getExchangeAdapter(name: string): ExchangeAdapter {
  return adapters[name] ?? binanceAdapter;
}

/** Get all available exchange IDs */
export function getAvailableExchanges(): string[] {
  return Object.keys(adapters);
}
